import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { CoreFiltersService } from '../../core';

@Component({
  selector: 'lms-agents',
  templateUrl: './agents.component.html',
  styleUrls: ['./agents.component.scss']
})
export class AgentsComponent implements OnInit {
  public listId = 'ADMINS_LIST';
  public fieldNames: any = ['name', 'surname', 'role', 'email'];
  public filterOptions: any;
  public toolbarConfig: any;

  constructor(
    public titleService: Title,
    public translate: TranslateService,
    public agentsFilters: CoreFiltersService
  ) {}

  ngOnInit() {
    this.toolbarConfig = {
      list: {
        listId: this.listId,
        download: true,
        filterRow: true,
        columnChooser: true,
        skeletor: true
      }
    };
    this.titleService.setTitle(
      this.translate.instant('pageTitle.agents') + ' - ' + this.translate.instant('pageTitle.gamelearn')
    );
    this.filterOptions = {
      filterName: 'agent',
      scheme: ['distributorId', { name: 'clientId', searchField: 'clientIds' }, 'role', 'countryId', 'lang']
    };
  }
}
